import { render, staticRenderFns } from "./PcCheckExample.vue?vue&type=template&id=28c9a9dc"
import script from "./PcCheckExample.vue?vue&type=script&lang=js"
export * from "./PcCheckExample.vue?vue&type=script&lang=js"
import style0 from "./PcCheckExample.vue?vue&type=style&index=0&id=28c9a9dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports